import { render } from "./CatalogTitle.vue?vue&type=template&id=162f9865&scoped=true"
import script from "./CatalogTitle.vue?vue&type=script&lang=js"
export * from "./CatalogTitle.vue?vue&type=script&lang=js"

import "./CatalogTitle.vue?vue&type=style&index=0&id=162f9865&scoped=true&lang=css"

import exportComponent from "/Users/remy/Sites/baghera/WocUp/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-162f9865"]])

export default __exports__